<section class="secao-noticias" aria-labelledby="secao-noticias-titulo">
  <h2 class="secao-noticias-titulo" id="secao-noticias-titulo">Notícias</h2>

  <div class="secao-noticias-filtros" role="group" aria-label="Filtrar notícias por categoria">
    @for (filtro of filtros(); track filtro.id) {
      <button
        type="button"
        class="secao-noticias-filtro"
        [class.secao-noticias-filtro-ativo]="categoriaAtiva() === filtro.id"
        [style.--secao-noticias-filtro-cor]="filtro.cor"
        [attr.aria-pressed]="categoriaAtiva() === filtro.id"
        (click)="selecionarCategoria(filtro.id)"
      >
        <span class="secao-noticias-filtro-ponto" aria-hidden="true"></span>
        {{ filtro.rotulo }}
      </button>
    }
  </div>

  <div class="secao-noticias-busca-linha">
    <label class="secao-noticias-busca" for="secao-noticias-busca-input">
      <i-lucide name="search" size="18" aria-hidden="true"></i-lucide>
      <input
        id="secao-noticias-busca-input"
        type="search"
        placeholder="Buscar notícias"
        [value]="termoBusca()"
        (input)="aoDigitarBusca($event)"
      />
    </label>

    <a class="secao-noticias-ver-todas" routerLink="/noticias">
      Ver todas
      <i-lucide name="arrow-right" size="18" aria-hidden="true"></i-lucide>
    </a>
  </div>

  @if (noticiasPagina().length) {
    <div class="secao-noticias-grade">
      @for (noticia of noticiasPagina(); track noticia.id) {
        <app-noticia-card [noticia]="noticia"></app-noticia-card>
      }
    </div>

    @if (totalPaginas() > 1) {
      <div class="secao-noticias-paginacao" role="tablist" aria-label="Páginas de notícias">
        @for (pagina of paginas(); track pagina) {
          <button
            type="button"
            class="secao-noticias-ponto"
            role="tab"
            [class.secao-noticias-ponto-ativo]="paginaAtual() === pagina"
            [attr.aria-selected]="paginaAtual() === pagina"
            [attr.aria-label]="'Página ' + (pagina + 1)"
            (click)="irParaPagina(pagina)"
          ></button>
        }
      </div>
    }
  } @else if (!carregando()) {
    <p class="secao-noticias-vazio">Nenhuma notícia encontrada para essa busca.</p>
  }
</section>
